/**
 * schemas/cash — assignments, the ledger, and the composite the drawer loads.
 */
import { z } from 'zod';
import { assignmentSchema, transferRowSchema } from './assignment';
import { transactionSchema } from './transaction';

export * from './assignment';
export * from './transaction';

/**
 * GET /v1/cash/assignments/:id — the ledger drawer's SINGLE round trip.
 * The assignment, its whole ledger and its custody history arrive together,
 * because opening the drawer is one interaction and should be one request.
 */
export const assignmentDetailSchema = z.object({
  assignment: assignmentSchema,
  transactions: z.array(transactionSchema),
  transfers: z.array(transferRowSchema).default([]),
});
export type AssignmentDetail = z.infer<typeof assignmentDetailSchema>;
